import type { Store } from 'effector'

import { features } from '~/core/flags'

// indicates about enabled or disabled partners program feature
export const $partnersProgramEnabled: Store<boolean> = features.get(
  'partnersProgramEnabled',
  false
)
